import { render, staticRenderFns } from "./TransportSection.vue?vue&type=template&id=b1f18d9c&scoped=true&"
import script from "./TransportSection.vue?vue&type=script&lang=js&"
export * from "./TransportSection.vue?vue&type=script&lang=js&"
import style0 from "./TransportSection.vue?vue&type=style&index=0&id=b1f18d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f18d9c",
  null
  
)

export default component.exports